
import * as Yup from "yup";

export const countryValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  phonecode: Yup.string().required("Phonecode is required"),
  code: Yup.string().required("Country Code is required"),
});

export const stateValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  country: Yup.string().required("Please select Country"),
  code: Yup.string().required("State Code is required"),
});

export const cityValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  state: Yup.string().required("Please select State"),
  // code: Yup.string()
  //   .required("City Code is required")
  //   .matches(/^[0-9]+$/, "City Code must contain only numbers")
  //   .max(6, "City Code cannot exceed 6 digits"),
});

export const initiativeValidationSchema = Yup.object().shape({
  title: Yup.string().required("name is required"),
  edition: Yup.string().required("edition is required"),
  start_date: Yup.string().required("Start Date is required"),
  end_date: Yup.string().required("End Date is required"),
  city: Yup.string().required("City is required"),
  curator: Yup.string().required("Inititaitve Lead is required"),
  description: Yup.string()
    .required("Description is required")
    // .max(200, "Description must be at most 200 characters"),
    .test(
      "maxWords",
      "Description must be at most 200 words",
      function (value) {
        if (!value) return true; // required handles empty
        const wordCount = value.trim().split(/\s+/).length;
        return wordCount <= 200;
      }
    ),
});

export const showValidationSchema = Yup.object().shape({
  title: Yup.string().required("Please Enter Name"),
  category: Yup.string().required("Please select Category"),
  genre: Yup.string().required("Please select Genre"),
  initiative: Yup.string().required("Please select Initiative"),
  show_length: Yup.string().required("Please select Show Length"),
  tags: Yup.string().required("Please enter Tags"),
  description: Yup.string().required("Please enter Description"),
});

export const categoryValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  icon: Yup.mixed().required("Icon for Art Form is required"),
  format_duration: Yup.array()
    .of(Yup.string())
    .min(1, "Please add at least one Format/Duration")
    .required("Please add at least one Format/Duration"),
});

export const genreValidationSchema = Yup.object().shape({
  category: Yup.array()
    .of(Yup.string().required())
    .min(1, "Please select at least one category")
    .required("Please select at least one category"),
  name: Yup.string().required("Name is required"),
});

export const rbacValidationSchema = Yup.object().shape({
  access: Yup.array()
    .of(Yup.string().required())
    .min(1, "Please select at least one access level")
    .required("Please select at least one access level"),
  title: Yup.string().required("Title is required"),
});

export const artistValidationSchema = Yup.object().shape({
  firstName: Yup.string().required("Please Enter FirstName"),
  lastName: Yup.string().required("Please Enter LastName"),
  email: Yup.string().email().required("Please Enter Email"),
  countryCode: Yup.string().required("Please Select Country Code"),
  mobileNumber: Yup.number().required("Please Enter Mobile No."),
  city: Yup.string().required("Please Select City"),
  state: Yup.string().required("Please Select State"),
  gender: Yup.string().required("Please Enter Gender"),
  dob: Yup.date().required("Please Enter Date Of Birth"),
  instgramProfile: Yup.string().url("Invalid URL"),
  // hearAbout: Yup.string().required("HearAbout is required"),
  referenceLinks: Yup.array()
    .of(
      Yup.string()
        .url("Invalid URL")
    )
    .max(3, "You can add a maximum of 3 locations")
  // description: Yup.string().required("Please Enter Bio"),
  // category: Yup.string().required("Please select Category"),
  // genre: Yup.string().required("Please select Genre"),
  // initiative: Yup.string().required("Please select Initiative"),
  // show_length: Yup.string().required("Please select Show Length"),
  // tags: Yup.string().required("Please enter Tags"),
  // description: Yup.string().required("Please enter Description"),
});
export const artistWithRoleValidationSchema = Yup.object().shape({
  firstName: Yup.string().required("Please Enter FirstName"),
  role: Yup.string().required("Please Enter Role"),
  lastName: Yup.string().required("Please Enter LastName"),
  email: Yup.string().email().required("Please Enter Email"),
  countryCode: Yup.string().required("Please Select Country Code"),
  mobileNumber: Yup.number().required("Please Enter Mobile No."),
  city: Yup.string().required("Please Select City"),
  state: Yup.string().required("Please Select State"),
  gender: Yup.string().required("Please Enter Gender"),
  dob: Yup.date().required("Please Enter Date Of Birth"),
  instgramProfile: Yup.string().url("Invalid URL"),
  // hearAbout: Yup.string().required("HearAbout is required"),
  referenceLinks: Yup.array()
    .of(
      Yup.string()
        .url("Invalid URL")
    )
    .max(3, "You can add a maximum of 3 locations")
  // description: Yup.string().required("Please Enter Bio"),
  // category: Yup.string().required("Please select Category"),
  // genre: Yup.string().required("Please select Genre"),
  // initiative: Yup.string().required("Please select Initiative"),
  // show_length: Yup.string().required("Please select Show Length"),
  // tags: Yup.string().required("Please enter Tags"),
  // description: Yup.string().required("Please enter Description"),
});

export const scheduleValidationSchema = Yup.object().shape({
  initiative: Yup.string().required("Please Select an Initiative"),
  venue: Yup.string().required("Please Select a Venue"),
  performanceVenue: Yup.string().required("Please Select Stage"),
  date: Yup.date().required("Please Select Date"),
  start_time: Yup.string().required("Please Select Time."),
  end_time: Yup.string().required("Please Select End Time."),
  // .test("is-after-start", "End time must be after start", function (value) {
  //   const { start_time } = this.parent;
  //   let [h, m] = start_time.split(":").map(Number);
  //   let StartTime = h * 60 + m;
  //   let [eh, em] = value.split(":").map(Number);
  //   let endTime = eh * 60 + em;
  //   return endTime > StartTime;
  // }),
  // show: Yup.string().required("Please Select Show"),
});

export const projectBannerValidationSchema = Yup.object().shape({
  bannerImage: Yup.mixed().required("Please upload a banner image"),
});

export const projectValidationSchema = Yup.object().shape({
  conceptTitle: Yup.string()
    .required("Concept Title is required")
    .max(50, "Concept Title cannot exceed 50 characters"),
  duration: Yup.string().required("Duration is required"),
  artForm: Yup.string().required("Please select Art Form"),
  genre: Yup.string().required("Please select Genre"),
  conceptNote: Yup.string(),
  // .test("is-after-start", "End time must be after start", function (value) {
  //   const { start_time } = this.parent;
  //   let [h, m] = start_time.split(":").map(Number);
  //   let StartTime = h * 60 + m;
  //   let [eh, em] = value.split(":").map(Number);
  //   let endTime = eh * 60 + em;
  //   return endTime > StartTime;
  // }),
  // show: Yup.string().required("Please Select Show"),
});

export const notificationValidationSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  message: Yup.string().required("Message is required"),
  audience: Yup.string().required("Please select audience"),
});

export const splashScreenValidationSchema = Yup.object().shape({
  splash_screen: Yup.object().shape({
    title: Yup.string().required("Title is required"),
    subtitle: Yup.string().required("Sub Title is required"),
    image: Yup.mixed().required("Image is required"),
  }),
});

export const onBoardingScreenValidationSchema = Yup.object().shape({
  onboarding_screen: Yup.array()
    .of(
      Yup.object().shape({
        title: Yup.string().required("Title is required"),
        subtitle: Yup.string().required("Sub Title is required"),
        button_text: Yup.string().required("Button Text is required"),
        image: Yup.mixed().required("Image is required"),
      })
    )
});

export const guestCountValidationSchema = Yup.object().shape({
  guest_count: Yup.number()
    .typeError("Please enter a valid number.")
    .required("Please enter guest count.")
    .min(0, "Guest count cannot be negative.")
    .max(999, "Guest count cannot exceed 999."),
});